import { render, staticRenderFns } from "./blogDetail.vue?vue&type=template&id=4ee99ac2&"
import script from "./blogDetail.vue?vue&type=script&lang=ts&"
export * from "./blogDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports